/* Craftsbazaar corporate — reveal + infinite, draggable logo marquee. Scoped to .cb-corp. */
(function () {
  'use strict';

  function initReveal(root) {
    root.classList.add('is-js');
    var els = root.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initLogos(root) {
    root.querySelectorAll('.logos[data-marquee]').forEach(function (box) {
      var vp = box.querySelector('.logos-viewport');
      var track = box.querySelector('.logos-track');
      if (!vp || !track) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      box.classList.add('is-live');
      var speed = parseFloat(box.getAttribute('data-speed')) || 40;
      var half = track.scrollWidth / 2;
      function measure() { half = track.scrollWidth / 2; }
      if ('ResizeObserver' in window) { new ResizeObserver(measure).observe(track); }
      else { window.addEventListener('resize', measure); }

      var offset = 0, last = null, raf = null, paused = false;
      var dragging = false, startX = 0, startOffset = 0, moved = 0, lastX = 0, lastT = 0, vel = 0;

      function wrap() { if (half > 0) { while (offset <= -half) offset += half; while (offset > 0) offset -= half; } }
      function apply() { track.style.transform = 'translateX(' + offset + 'px)'; }
      function frame(t) {
        if (last == null) last = t;
        var dt = (t - last) / 1000; last = t;
        if (!paused && !dragging) { offset -= speed * dt; wrap(); apply(); }
        raf = requestAnimationFrame(frame);
      }
      function start() { if (!raf) { last = null; raf = requestAnimationFrame(frame); } }
      function stop() { if (raf) { cancelAnimationFrame(raf); raf = null; } }

      vp.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') paused = true; });
      vp.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') paused = false; });
      vp.addEventListener('pointerdown', function (e) {
        dragging = true; moved = 0; startX = e.clientX; startOffset = offset;
        lastX = e.clientX; lastT = performance.now(); vel = 0;
        vp.classList.add('is-drag');
        try { vp.setPointerCapture(e.pointerId); } catch (_) {}
      });
      vp.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var dx = e.clientX - startX; moved = Math.abs(dx);
        offset = startOffset + dx; wrap(); apply();
        var now = performance.now(), ddt = now - lastT;
        if (ddt > 0) vel = (e.clientX - lastX) / ddt * 1000;
        lastX = e.clientX; lastT = now;
      });
      function endDrag(e) {
        if (!dragging) return;
        dragging = false; vp.classList.remove('is-drag');
        try { vp.releasePointerCapture(e.pointerId); } catch (_) {}
        var v = vel, steps = 0;
        (function glide() {
          if (dragging || Math.abs(v) < 8) return;
          offset += v * 0.016; v *= 0.92; wrap(); apply();
          if (steps++ < 140) requestAnimationFrame(glide);
        })();
      }
      vp.addEventListener('pointerup', endDrag);
      vp.addEventListener('pointercancel', endDrag);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      vp.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });

      start();
    });
  }

  function initSwipe(root) {
    root.querySelectorAll('.testi-grid').forEach(function (sc) {
      var down = false, sx = 0, sl = 0, moved = 0;
      sc.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return; // touch/trackpad already swipe natively
        down = true; moved = 0; sx = e.clientX; sl = sc.scrollLeft;
        sc.classList.add('is-drag');
        try { sc.setPointerCapture(e.pointerId); } catch (_) {}
      });
      sc.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx; moved = Math.abs(dx);
        sc.scrollLeft = sl - dx;
      });
      function up(e) {
        if (!down) return;
        down = false; sc.classList.remove('is-drag');
        try { sc.releasePointerCapture(e.pointerId); } catch (_) {}
      }
      sc.addEventListener('pointerup', up);
      sc.addEventListener('pointercancel', up);
      sc.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  function boot() {
    document.querySelectorAll('.cb-corp').forEach(function (root) {
      initReveal(root);
      initLogos(root);
      initSwipe(root);
    });
  }
  if (document.readyState !== 'loading') { boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); }
})();